import { createFileRoute } from "@tanstack/react-router";
import { ArticleLayout } from "@/components/article-layout";
import { getArticle } from "@/content/articles";
import { abs, articleHead } from "@/content/seo";
import cover from "@/assets/sylwia-sofa-granice.jpg.asset.json";

const article = getArticle("stawianie-granic-w-pracy");

export const Route = createFileRoute("/stawianie-granic-w-pracy")({
  head: () => articleHead(article, abs(cover.url)),
  component: () => <ArticleLayout article={article} />,
});
